"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setInput = function (input) { return ({
    type: "SET_INPUT",
    input: input
}); };
//# sourceMappingURL=inputActions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/azsearchstore/dist/actions/inputActions.js
// module id = 116
// module chunks = 0